// frontend/packages/business-console/src/pages/Invoices/demoInvoiceDetail.js
//
// Detail-level fixtures for the Invoice detail page. Mirrors
// demoQuoteDetail.js but with invoice-specific extras:
//   - Per-invoice payments list (CrmPayment rows)
//   - Refund / dispute / failure visual states
//
// Activated via `?demo=1`. The list-view fixtures in demoData.js carry
// the same ids — clicking through from list → detail in demo mode
// works end-to-end.

const ACME = {
  _id: 'demo_customer_acme',
  firstName: 'Casey',
  lastName: 'Donnelly',
  companyName: 'Acme Roofing LLC',
  email: 'casey@acme-roofing.example',
  phone: '(312) 555-0142',
  address: {
    line1: '240 N Industrial Ave',
    city: 'Aurora',
    state: 'IL',
    postalCode: '60506',
  },
};

const KIM = {
  _id: 'demo_customer_kim',
  firstName: 'Sarah',
  lastName: 'Kim',
  email: 'sarah.kim@example.test',
  phone: '(773) 555-0124',
  address: {
    line1: '2418 W Belmont Ave, Apt 3',
    city: 'Chicago',
    state: 'IL',
    postalCode: '60618',
  },
};

const HENDERSON = {
  _id: 'demo_customer_henderson',
  firstName: 'Lee',
  lastName: 'Henderson',
  companyName: 'Henderson Group',
  email: 'lee@hendersongroup.example',
  phone: '(630) 555-0177',
  address: {
    line1: '4400 Corporate Way, Suite 200',
    city: 'Lisle',
    state: 'IL',
    postalCode: '60532',
  },
};

const PINEWOOD = {
  _id: 'demo_customer_pinewood',
  firstName: 'Marcus',
  lastName: 'Allen',
  companyName: 'Pinewood Estates HOA',
  email: 'manager@pinewoodestates.example',
  phone: '(847) 555-0119',
  address: {
    line1: '1 Pinewood Dr',
    city: 'Glenview',
    state: 'IL',
    postalCode: '60025',
  },
};

const WAGNER = {
  _id: 'demo_customer_wagner',
  firstName: 'Olivia',
  lastName: 'Wagner',
  companyName: 'Wagner Hospitality',
  email: 'olivia@wagnerhospitality.example',
  phone: '(312) 555-0166',
  address: {
    line1: '555 Lake Shore Blvd',
    city: 'Chicago',
    state: 'IL',
    postalCode: '60611',
  },
};

const SANTOS = {
  _id: 'demo_customer_santos',
  firstName: 'Maria',
  lastName: 'Santos',
  email: 'maria.santos@example.test',
  phone: '(708) 555-0188',
  address: {
    line1: '1132 Oak St',
    city: 'Naperville',
    state: 'IL',
    postalCode: '60540',
  },
};

const TILBURY = {
  _id: 'demo_customer_tilbury',
  firstName: 'Mark',
  lastName: 'Tilbury',
  companyName: 'Tilbury Construction',
  email: 'mark@tilburyconstruction.example',
  phone: '(847) 555-0193',
  address: {
    line1: '78 Industrial Park Dr',
    city: 'Schaumburg',
    state: 'IL',
    postalCode: '60173',
  },
};

const WHITFIELD = {
  _id: 'demo_customer_whitfield',
  firstName: 'Jordan',
  lastName: 'Whitfield',
  email: 'jordan.whitfield@example.test',
  phone: '(312) 555-0210',
  address: {
    line1: '84 N Lake St',
    city: 'Aurora',
    state: 'IL',
    postalCode: '60506',
  },
};

const OBRIEN = {
  _id: 'demo_customer_obrien',
  firstName: 'Madelyn',
  lastName: "O'Brien",
  email: 'madelyn.obrien@example.test',
  phone: '(815) 555-0145',
  address: {
    line1: '12 Birch Ln',
    city: 'Joliet',
    state: 'IL',
    postalCode: '60432',
  },
};

const DEMO_INVOICES_FULL = {
  // ── Paid ────────────────────────────────────────────────────────
  demo_invoice_184: {
    invoice: {
      _id: 'demo_invoice_184',
      number: 'INV-0184',
      state: 'paid',
      customerId: 'demo_customer_acme',
      quoteId: 'demo_quote_91',
      title: 'Storm damage repair',
      lineItems: [
        {
          id: 'li_1',
          position: 0,
          description: 'Tear-off + haul-away (existing 28-square)',
          quantity: '28',
          unitPrice: 12500,
          lineTotal: 350000,
        },
        {
          id: 'li_2',
          position: 1,
          description: 'New architectural shingle (GAF Timberline HDZ)',
          quantity: '28',
          unitPrice: 8500,
          lineTotal: 238000,
        },
        {
          id: 'li_3',
          position: 2,
          description: 'Synthetic underlayment + ice/water shield',
          quantity: '1',
          unitPrice: 42000,
          lineTotal: 42000,
        },
        {
          id: 'li_4',
          position: 3,
          description: 'Step + drip flashing replacement',
          quantity: '1',
          unitPrice: 18000,
          lineTotal: 18000,
        },
      ],
      subtotal: 648000,
      discountTotal: 403000,
      taxTotal: 0,
      total: 245000,
      amountPaid: 245000,
      amountRefunded: 0,
      amountDue: 0,
      currency: 'USD',
      dueAt: '2026-06-12T00:00:00Z',
      terms: 'Net 30. 1.5%/mo on past-due balances.',
      notes: 'Insurance-discounted billing per claim 5402.',
      viewToken: 'demo-acme-inv184-fake-view-token',
      sentAt: '2026-05-24T14:30:00Z',
      viewedAt: '2026-05-25T09:08:00Z',
      paidAt: '2026-05-26T14:22:00Z',
      voidedAt: null,
      stripePaymentIntentId: 'pi_demo_acme_184',
      pdf: {
        version: 1,
        blobUrl: 'https://stub.blob.local/invoices/demo-inv184.pdf',
        renderedAt: '2026-05-24T14:30:01Z',
        templateVersion: 'invoice-v1',
      },
      createdAt: '2026-05-24T11:30:00Z',
      updatedAt: '2026-05-26T14:22:00Z',
    },
    customer: ACME,
    payments: [
      {
        _id: 'demo_pay_184_1',
        state: 'succeeded',
        invoiceId: 'demo_invoice_184',
        customerId: 'demo_customer_acme',
        stripePaymentIntentId: 'pi_demo_acme_184',
        paymentMethod: 'card',
        amount: 245000,
        applicationFee: 4900,
        stripeFee: 7625,
        netToClient: 232475,
        currency: 'USD',
        paidAt: '2026-05-26T14:22:00Z',
        refunds: [],
        createdAt: '2026-05-26T14:21:00Z',
      },
    ],
    availableActions: {
      canEdit: false,
      canDelete: false,
      canSend: false,
      canResend: false,
      canVoid: false,
      canPaymentIntent: false,
      allowedTransitions: [],
    },
  },

  // ── Partial (split payment in flight) ──────────────────────────
  demo_invoice_182: {
    invoice: {
      _id: 'demo_invoice_182',
      number: 'INV-0182',
      state: 'partial',
      customerId: 'demo_customer_henderson',
      title: 'Annual maintenance — Q2',
      lineItems: [
        {
          id: 'li_1',
          position: 0,
          description: 'Quarterly system inspection (4 visits/yr)',
          quantity: '4',
          unitPrice: 65000,
          lineTotal: 260000,
        },
        {
          id: 'li_2',
          position: 1,
          description: 'Priority service-call response',
          quantity: '1',
          unitPrice: 120000,
          lineTotal: 120000,
        },
        {
          id: 'li_3',
          position: 2,
          description: 'Filter + minor consumables',
          quantity: '1',
          unitPrice: 160000,
          lineTotal: 160000,
        },
      ],
      subtotal: 540000,
      discountTotal: 0,
      taxTotal: 0,
      total: 540000,
      amountPaid: 270000,
      amountRefunded: 0,
      amountDue: 270000,
      currency: 'USD',
      dueAt: '2026-06-15T00:00:00Z',
      terms: 'Net 30. 50% deposit collected; balance due on schedule.',
      notes: 'Quarterly cadence — next visit week of 7/14.',
      viewToken: 'demo-henderson-inv182-fake-view-token',
      sentAt: '2026-05-22T13:50:00Z',
      viewedAt: '2026-05-22T16:30:00Z',
      paidAt: null,
      voidedAt: null,
      stripePaymentIntentId: 'pi_demo_henderson_182_b',
      pdf: {
        version: 1,
        blobUrl: 'https://stub.blob.local/invoices/demo-inv182.pdf',
        renderedAt: '2026-05-22T13:50:01Z',
        templateVersion: 'invoice-v1',
      },
      createdAt: '2026-05-22T13:40:00Z',
      updatedAt: '2026-05-25T16:00:00Z',
    },
    customer: HENDERSON,
    payments: [
      {
        _id: 'demo_pay_182_1',
        state: 'succeeded',
        invoiceId: 'demo_invoice_182',
        customerId: 'demo_customer_henderson',
        stripePaymentIntentId: 'pi_demo_henderson_182_a',
        paymentMethod: 'card',
        amount: 270000,
        applicationFee: 5400,
        stripeFee: 8400,
        netToClient: 256200,
        currency: 'USD',
        paidAt: '2026-05-25T16:00:00Z',
        refunds: [],
        createdAt: '2026-05-25T15:59:00Z',
      },
    ],
    availableActions: {
      canEdit: false,
      canDelete: false,
      canSend: false,
      canResend: true,
      canVoid: true,
      canPaymentIntent: true,
      allowedTransitions: ['paid', 'overdue', 'void'],
    },
  },

  // ── Overdue ────────────────────────────────────────────────────
  demo_invoice_179: {
    invoice: {
      _id: 'demo_invoice_179',
      number: 'INV-0179',
      state: 'overdue',
      customerId: 'demo_customer_pinewood',
      title: 'Common-area landscaping',
      lineItems: [
        {
          id: 'li_1',
          position: 0,
          description: 'Spring landscaping refresh — entrance + common areas',
          quantity: '1',
          unitPrice: 215000,
          lineTotal: 215000,
        },
      ],
      subtotal: 215000,
      discountTotal: 0,
      taxTotal: 0,
      total: 215000,
      amountPaid: 0,
      amountRefunded: 0,
      amountDue: 215000,
      currency: 'USD',
      dueAt: '2026-05-15T00:00:00Z',
      terms: 'Net 15. 1.5%/mo on past-due balances.',
      notes:
        'Reminder sent 5/16, 5/22. Manager out of office until 5/30 — follow up week of 6/2.',
      viewToken: 'demo-pinewood-inv179-fake-view-token',
      sentAt: '2026-04-30T11:30:00Z',
      viewedAt: '2026-05-01T08:00:00Z',
      paidAt: null,
      voidedAt: null,
      stripePaymentIntentId: null,
      pdf: {
        version: 1,
        blobUrl: 'https://stub.blob.local/invoices/demo-inv179.pdf',
        renderedAt: '2026-04-30T11:30:01Z',
        templateVersion: 'invoice-v1',
      },
      createdAt: '2026-04-30T11:00:00Z',
      updatedAt: '2026-05-16T03:00:00Z',
    },
    customer: PINEWOOD,
    payments: [],
    availableActions: {
      canEdit: false,
      canDelete: false,
      canSend: false,
      canResend: true,
      canVoid: true,
      canPaymentIntent: true,
      allowedTransitions: ['partial', 'paid', 'void'],
    },
  },

  // ── Sent ───────────────────────────────────────────────────────
  demo_invoice_177: {
    invoice: {
      _id: 'demo_invoice_177',
      number: 'INV-0177',
      state: 'sent',
      customerId: 'demo_customer_tilbury',
      quoteId: 'demo_quote_94',
      title: 'Tear-off + new shingle',
      lineItems: [
        {
          id: 'li_1',
          position: 0,
          description: 'Tear-off + dump (commercial property, 42-square)',
          quantity: '42',
          unitPrice: 14000,
          lineTotal: 588000,
        },
      ],
      subtotal: 588000,
      discountTotal: 167000,
      taxTotal: 0,
      total: 421000,
      amountPaid: 0,
      amountRefunded: 0,
      amountDue: 421000,
      currency: 'USD',
      dueAt: '2026-06-25T00:00:00Z',
      terms: 'Net 30',
      notes: 'Volume discount per contractor agreement.',
      viewToken: 'demo-tilbury-inv177-fake-view-token',
      sentAt: '2026-05-26T10:00:00Z',
      viewedAt: null,
      paidAt: null,
      voidedAt: null,
      stripePaymentIntentId: null,
      pdf: {
        version: 1,
        blobUrl: 'https://stub.blob.local/invoices/demo-inv177.pdf',
        renderedAt: '2026-05-26T10:00:01Z',
        templateVersion: 'invoice-v1',
      },
      createdAt: '2026-05-26T10:00:00Z',
      updatedAt: '2026-05-26T10:00:00Z',
    },
    customer: TILBURY,
    payments: [],
    availableActions: {
      canEdit: false,
      canDelete: false,
      canSend: false,
      canResend: true,
      canVoid: true,
      canPaymentIntent: true,
      allowedTransitions: ['viewed', 'partial', 'paid', 'overdue', 'void'],
    },
  },

  // ── Viewed ─────────────────────────────────────────────────────
  demo_invoice_178: {
    invoice: {
      _id: 'demo_invoice_178',
      number: 'INV-0178',
      state: 'viewed',
      customerId: 'demo_customer_santos',
      title: 'Gutter cleaning + soffit repair',
      lineItems: [
        {
          id: 'li_1',
          position: 0,
          description: 'Gutter cleaning, full perimeter (single-story)',
          quantity: '1',
          unitPrice: 25000,
          lineTotal: 25000,
        },
        {
          id: 'li_2',
          position: 1,
          description: 'Soffit panel replacement — 3 panels',
          quantity: '3',
          unitPrice: 14000,
          lineTotal: 42000,
        },
      ],
      subtotal: 67000,
      discountTotal: 0,
      taxTotal: 500,
      total: 67500,
      amountPaid: 0,
      amountRefunded: 0,
      amountDue: 67500,
      currency: 'USD',
      dueAt: '2026-06-22T00:00:00Z',
      terms: 'Net 15',
      notes: '',
      viewToken: 'demo-santos-inv178-fake-view-token',
      sentAt: '2026-05-22T16:15:00Z',
      viewedAt: '2026-05-26T08:30:00Z',
      paidAt: null,
      voidedAt: null,
      stripePaymentIntentId: null,
      pdf: {
        version: 1,
        blobUrl: 'https://stub.blob.local/invoices/demo-inv178.pdf',
        renderedAt: '2026-05-22T16:15:01Z',
        templateVersion: 'invoice-v1',
      },
      createdAt: '2026-05-22T16:15:00Z',
      updatedAt: '2026-05-26T08:30:00Z',
    },
    customer: SANTOS,
    payments: [],
    availableActions: {
      canEdit: false,
      canDelete: false,
      canSend: false,
      canResend: true,
      canVoid: true,
      canPaymentIntent: true,
      allowedTransitions: ['partial', 'paid', 'overdue', 'void'],
    },
  },

  // ── Draft ──────────────────────────────────────────────────────
  demo_invoice_176: {
    invoice: {
      _id: 'demo_invoice_176',
      number: 'INV-0176',
      state: 'draft',
      customerId: 'demo_customer_whitfield',
      title: 'Back deck — labor + materials',
      lineItems: [
        {
          id: 'li_1',
          position: 0,
          description: 'Pressure-treated framing + decking material',
          quantity: '1',
          unitPrice: 145000,
          lineTotal: 145000,
        },
        {
          id: 'li_2',
          position: 1,
          description: 'Labor — 3 crew × 2 days',
          quantity: '1',
          unitPrice: 150000,
          lineTotal: 150000,
        },
      ],
      subtotal: 295000,
      discountTotal: 0,
      taxTotal: 0,
      total: 295000,
      amountPaid: 0,
      amountRefunded: 0,
      amountDue: 295000,
      currency: 'USD',
      dueAt: null,
      terms: '',
      notes: 'Pending final scope confirmation with Jordan.',
      viewToken: null,
      sentAt: null,
      viewedAt: null,
      paidAt: null,
      voidedAt: null,
      stripePaymentIntentId: null,
      pdf: null,
      createdAt: '2026-05-26T14:40:00Z',
      updatedAt: '2026-05-26T14:40:00Z',
    },
    customer: WHITFIELD,
    payments: [],
    availableActions: {
      canEdit: true,
      canDelete: true,
      canSend: true,
      canResend: false,
      canVoid: true,
      canPaymentIntent: false,
      allowedTransitions: ['sent', 'void'],
    },
  },

  // ── Void ───────────────────────────────────────────────────────
  demo_invoice_175: {
    invoice: {
      _id: 'demo_invoice_175',
      number: 'INV-0175',
      state: 'void',
      customerId: 'demo_customer_obrien',
      title: 'Deck refinish (voided — quote declined)',
      lineItems: [
        {
          id: 'li_1',
          position: 0,
          description: 'Strip + reseal existing deck (200 sq ft)',
          quantity: '200',
          unitPrice: 340,
          lineTotal: 68000,
        },
      ],
      subtotal: 68000,
      discountTotal: 0,
      taxTotal: 0,
      total: 68000,
      amountPaid: 0,
      amountRefunded: 0,
      amountDue: 0,
      currency: 'USD',
      dueAt: null,
      terms: '',
      notes: 'Customer declined quote Q-0089 — invoice voided same day.',
      viewToken: 'demo-obrien-inv175-fake-view-token',
      sentAt: null,
      viewedAt: null,
      paidAt: null,
      voidedAt: '2026-05-24T17:35:00Z',
      stripePaymentIntentId: null,
      pdf: null,
      createdAt: '2026-05-21T10:00:00Z',
      updatedAt: '2026-05-24T17:35:00Z',
    },
    customer: OBRIEN,
    payments: [],
    availableActions: {
      canEdit: false,
      canDelete: false,
      canSend: false,
      canResend: false,
      canVoid: false,
      canPaymentIntent: false,
      allowedTransitions: [],
    },
  },

  // ── Paid (with refund) ─────────────────────────────────────────
  demo_invoice_180: {
    invoice: {
      _id: 'demo_invoice_180',
      number: 'INV-0180',
      state: 'paid',
      customerId: 'demo_customer_wagner',
      quoteId: 'demo_quote_90',
      title: 'New install — 4 units',
      lineItems: [
        {
          id: 'li_1',
          position: 0,
          description: 'Rooftop unit, 5-ton (incl. install)',
          quantity: '4',
          unitPrice: 78000,
          lineTotal: 312000,
        },
      ],
      subtotal: 312000,
      discountTotal: 0,
      taxTotal: 0,
      total: 312000,
      amountPaid: 312000,
      amountRefunded: 25000,
      amountDue: 0,
      currency: 'USD',
      dueAt: '2026-06-08T00:00:00Z',
      terms: 'Net 30',
      notes:
        'Wagner requested partial refund on Unit 3 — handled outside Stripe; recorded for the ledger.',
      viewToken: 'demo-wagner-inv180-fake-view-token',
      sentAt: '2026-05-23T15:20:00Z',
      viewedAt: '2026-05-24T08:30:00Z',
      paidAt: '2026-05-25T09:30:00Z',
      voidedAt: null,
      stripePaymentIntentId: 'pi_demo_wagner_180',
      pdf: {
        version: 1,
        blobUrl: 'https://stub.blob.local/invoices/demo-inv180.pdf',
        renderedAt: '2026-05-23T15:20:01Z',
        templateVersion: 'invoice-v1',
      },
      createdAt: '2026-05-23T15:20:00Z',
      updatedAt: '2026-05-27T11:00:00Z',
    },
    customer: WAGNER,
    payments: [
      {
        _id: 'demo_pay_180_1',
        state: 'succeeded',
        invoiceId: 'demo_invoice_180',
        customerId: 'demo_customer_wagner',
        stripePaymentIntentId: 'pi_demo_wagner_180',
        paymentMethod: 'card',
        amount: 312000,
        applicationFee: 6240,
        stripeFee: 9358,
        netToClient: 296402,
        currency: 'USD',
        paidAt: '2026-05-25T09:30:00Z',
        refunds: [
          {
            amount: 25000,
            refundedAt: '2026-05-27T11:00:00Z',
            reason: 'Customer-requested partial refund',
          },
        ],
        createdAt: '2026-05-25T09:29:00Z',
      },
    ],
    availableActions: {
      canEdit: false,
      canDelete: false,
      canSend: false,
      canResend: false,
      canVoid: false,
      canPaymentIntent: false,
      allowedTransitions: [],
    },
  },

  // ── Paid — Sarah Kim (small ticket) ────────────────────────────
  demo_invoice_183: {
    invoice: {
      _id: 'demo_invoice_183',
      number: 'INV-0183',
      state: 'paid',
      customerId: 'demo_customer_kim',
      title: 'Service call — water heater',
      lineItems: [
        {
          id: 'li_1',
          position: 0,
          description: 'Diagnostic + thermostat replacement',
          quantity: '1',
          unitPrice: 89500,
          lineTotal: 89500,
        },
      ],
      subtotal: 89500,
      discountTotal: 0,
      taxTotal: 0,
      total: 89500,
      amountPaid: 89500,
      amountRefunded: 0,
      amountDue: 0,
      currency: 'USD',
      dueAt: '2026-06-10T00:00:00Z',
      terms: 'Net 15',
      notes: '',
      viewToken: 'demo-kim-inv183-fake-view-token',
      sentAt: '2026-05-23T09:25:00Z',
      viewedAt: '2026-05-23T19:10:00Z',
      paidAt: '2026-05-26T11:08:00Z',
      voidedAt: null,
      stripePaymentIntentId: 'pi_demo_kim_183',
      pdf: {
        version: 1,
        blobUrl: 'https://stub.blob.local/invoices/demo-inv183.pdf',
        renderedAt: '2026-05-23T09:25:01Z',
        templateVersion: 'invoice-v1',
      },
      createdAt: '2026-05-23T09:15:00Z',
      updatedAt: '2026-05-26T11:08:00Z',
    },
    customer: KIM,
    payments: [
      {
        _id: 'demo_pay_183_1',
        state: 'succeeded',
        invoiceId: 'demo_invoice_183',
        customerId: 'demo_customer_kim',
        stripePaymentIntentId: 'pi_demo_kim_183',
        paymentMethod: 'card',
        amount: 89500,
        applicationFee: 1790,
        stripeFee: 2890,
        netToClient: 84820,
        currency: 'USD',
        paidAt: '2026-05-26T11:08:00Z',
        refunds: [],
        createdAt: '2026-05-26T11:07:00Z',
      },
    ],
    availableActions: {
      canEdit: false,
      canDelete: false,
      canSend: false,
      canResend: false,
      canVoid: false,
      canPaymentIntent: false,
      allowedTransitions: [],
    },
  },

  // ── Paid — Henderson service visit ─────────────────────────────
  demo_invoice_181: {
    invoice: {
      _id: 'demo_invoice_181',
      number: 'INV-0181',
      state: 'paid',
      customerId: 'demo_customer_henderson',
      title: 'Service visit',
      lineItems: [
        {
          id: 'li_1',
          position: 0,
          description: 'Emergency dispatch + repair',
          quantity: '1',
          unitPrice: 137500,
          lineTotal: 137500,
        },
      ],
      subtotal: 137500,
      discountTotal: 0,
      taxTotal: 0,
      total: 137500,
      amountPaid: 137500,
      amountRefunded: 0,
      amountDue: 0,
      currency: 'USD',
      dueAt: '2026-06-09T00:00:00Z',
      terms: 'Net 30',
      notes: '',
      viewToken: 'demo-henderson-inv181-fake-view-token',
      sentAt: '2026-05-19T10:15:00Z',
      viewedAt: '2026-05-19T13:00:00Z',
      paidAt: '2026-05-25T16:45:00Z',
      voidedAt: null,
      stripePaymentIntentId: 'pi_demo_henderson_181',
      pdf: {
        version: 1,
        blobUrl: 'https://stub.blob.local/invoices/demo-inv181.pdf',
        renderedAt: '2026-05-19T10:15:01Z',
        templateVersion: 'invoice-v1',
      },
      createdAt: '2026-05-19T10:00:00Z',
      updatedAt: '2026-05-25T16:45:00Z',
    },
    customer: HENDERSON,
    payments: [
      {
        _id: 'demo_pay_181_1',
        state: 'succeeded',
        invoiceId: 'demo_invoice_181',
        customerId: 'demo_customer_henderson',
        stripePaymentIntentId: 'pi_demo_henderson_181',
        paymentMethod: 'ach',
        amount: 137500,
        applicationFee: 2750,
        stripeFee: 800,
        netToClient: 133950,
        currency: 'USD',
        paidAt: '2026-05-25T16:45:00Z',
        refunds: [],
        createdAt: '2026-05-25T16:44:00Z',
      },
    ],
    availableActions: {
      canEdit: false,
      canDelete: false,
      canSend: false,
      canResend: false,
      canVoid: false,
      canPaymentIntent: false,
      allowedTransitions: [],
    },
  },
};

const DEMO_BUSINESS = {
  name: 'UpRyzze Demo Co.',
  address: '1500 W Madison St, Chicago, IL 60607',
  email: 'hello@upryzze-demo.example',
  phone: '(312) 555-0100',
};

export function getDemoInvoiceDetail(id) {
  const found = DEMO_INVOICES_FULL[id];
  if (!found) return null;
  return {
    ...found,
    business: DEMO_BUSINESS,
  };
}

export { DEMO_BUSINESS };
